import { Home } from './pages/home'
import { Slider } from './components/slider'



class App {
  constructor() {
    if(document.querySelector('.home')) {
      const home = new Home;
    }

    if(document.querySelector(".background-slider")) {
      const slider = new Slider();
    }
  }
}

window.onload = function() {
  let app = new App();
};
